import React, { Component } from 'react'
import {Col, InputGroup, Label} from "reactstrap";
import {observer} from "mobx-react";
import {toJS} from 'mobx';
import CalendarioPicker from "../../../../comum/components/Calendario";
import SelectFiltro from '../../../../comum/components/SelectFiltro';
import MultiSelectFiltro from '../../../../comum/components/MultiSelectFiltro';
import {IconeSetaLink} from '../../../../comum/components/Icones'

@observer
export default class FiltroImpExp extends Component {

    constructor(props) {
        super(props);
        this.controller = this.props.controller;

    }

    render() {
        let camposXl = 3;

        return (
            <React.Fragment>
                <Col xl={3} md={4} sm={6} xs={12} className="mb-4">
                    <div className="w-100">
                        <Col xs={12} className="col-label px-0">
                            <Label>Período (ETA Operação)</Label>
                        </Col>

                        <Col xs={12} className="px-0">
                            <InputGroup className={this.controller.seletorPeriodo ? 'ativo' : ''}>
                                <CalendarioPicker visivel={this.controller.seletorPeriodo}
                                                    onChangeInicio={(valor) => this.controller.setDataInicioTemp(valor)}
                                                    onChangeFim={(valor) => this.controller.setDataFimTemp(valor)}
                                                    dataInicial={this.controller.dataInicial}
                                                    dataFinal={this.controller.dataFinal}
                                                    fechar={() => this.controller.alternarDataSeletor()}
                                                    filtrar={(valor) => this.controller.alterarPeriodo(valor)}
                                                    bloqueado={!this.controller.periodoAtivo}
                                                    /> 
                            </InputGroup>

                        </Col>
                    </div>
                <IconeSetaLink size="lg" className="link-arrow" />
                </Col>
                
                <SelectFiltro titulo="*Operação" xl={camposXl} md={4} sm={6} xs={12}
                        itens={this.controller.listaOperacoes}
                        onChange={this.controller.setOperacao}
                        valor={this.controller.operacao}
                        itensValor="Id" itensLabel="ViagemNavio"
                        alertaObrigatorio={!this.controller.obrigatoriosPreenchidos.operacao}
                        bloqueado={!this.controller.operacaoAtivo}
                />

                <SelectFiltro titulo="*Tipo de Movimentação" xl={camposXl} md={4} sm={6} xs={12}
                        itens={this.controller.listaTipoMovimentacao}
                        onChange={this.controller.setTipoMovimentacao}
                        itensValor="value" itensLabel="label"
                        valor={this.controller.tipoMovimentacao}
                        alertaObrigatorio={!this.controller.obrigatoriosPreenchidos.tipoMovimentacao}
                />

                <MultiSelectFiltro titulo="*Grupos" xl={camposXl} md={4} sm={6} xs={12}
                        itens={this.controller.listaGrupos}
                        onChange={this.controller.setGrupos}
                        valor={toJS(this.controller.grupos)}
                        itensValor="value" itensLabel="label"
                        alertaObrigatorio={!this.controller.obrigatoriosPreenchidos.grupos}
                />

                <MultiSelectFiltro titulo="Status" xl={camposXl} md={4} sm={6} xs={12}
                        itens={this.controller.listaStatus}
                        onChange={this.controller.setStatus}
                        itensValor="value" itensLabel="label"
                        valor={toJS(this.controller.status)}
                />
                <MultiSelectFiltro titulo="Tipo" xl={camposXl} md={4} sm={6} xs={12}
                        itens={this.controller.listaTipo}
                        onChange={this.controller.setTipo}
                        itensValor="value" itensLabel="label"
                        valor={toJS(this.controller.tipo)}
                />

            </React.Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/modules/consultas/movimentação/components/filtros/FiltroImpExp.js